<form [formGroup]="machForm" (ngSubmit)="onSubmit()">
  <div class="p-5">
    <div class="flex justify-center items-baseline flex-wrap">
      <div class="flex m-2">
        <mat-form-field [hideRequiredMarker]="true">
          <mat-label><i>k</i> value</mat-label>
          <input matInput formControlName="gammaVal" autocomplete="off">
          <mat-error *ngIf="machForm.invalid && machForm.touched">
            <span class="myerror">1.0 &lt; <i>k</i> &le; 1.67</span>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="flex m-2">
        <mat-form-field [hideRequiredMarker]="true">
          <mat-label>Mach value</mat-label>
          <input matInput formControlName="machVal" autocomplete="off">
        </mat-form-field>
    </div>
  </div>
  <div class="sbmtArea flex justify-center items-baseline flex-wrap">
    <button mat-raised-button type="submit" [disabled]="machForm.invalid">Calculate</button>
  </div>
</div>
</form>
    
  <div class="flex justify-center items-baseline flex-wrap" *ngIf="mBool">
    <table>
      <tr>
        <td>
          p / p<sub>0</sub>
        </td>
        <td> <span class="asana2">{{ isenp_pt()  | number:'.1-5' }}</span></td>
      </tr>
      <tr>
        <td>
          T / T<sub>0</sub>
          
        </td>
        <td>
          <span class="asana2">{{ isenT_Tt() | number:'.1-5' }}</span>
        </td>
      </tr>
      <tr>
        <td>

          A / A<sub>t</sub>
          <!-- <img src="assets/math/aas2.svg" alt=""> -->

            <!-- <span class="mathitalic">
                A &frasl; A*
            </span> -->
        </td>
        <td>
          <span class="asana2">{{ isenA_As() | number:'.1-5'}}</span>
        </td>
      </tr>
      <tr>
        <td>

          pA / p<sub>0</sub> A*
          <!-- <img src="assets/math/paptas2.svg" alt=""> -->

            <!-- <span class="mathitalic">
                pA &frasl; p<sub>t</sub> A*
            </span> -->
        </td>
        <td>
          <span class="asana2">{{ isenpA_ptAstar()  | number:'.1-5'  }}</span>
        </td>
      </tr>
      <tr>
        <td>
            <span>Prandtl-Meyer flow (ν)</span>
        </td>
        <td>
          <span class="asana2">{{ isenpm() | number:'.1-5' }}</span>
        </td>
      </tr>
      <tr>
        <td>
            <span>Mach angle (μ)</span>      
        <td>
          <span class="asana2">{{ isenmach_angle() | number:'.1-5' }}</span>      

        </td>
      </tr>
      <tr>
        <td>
            <span>C<sub>Fopt</sub></span>
            <!-- <img src="assets/math/cfopt_b.svg" alt=""> -->
        </td>
        <td>
            <span class="asana2">{{isen_cfopt() | number:'.1-5' }}</span>
        </td>
      </tr>
      <tr>
        <td>
          <!-- <img src="assets/math/rrt_b.svg" alt=""> -->
            <span>ρ/ρ <sub>0</sub></span>
        </td>
        <td>
          <span class="asana2">{{ isen_rhot() | number:'.1-5' }}</span>
        </td>
      </tr>
    </table>
  </div>